"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATUS_PRIORITIES = exports.StatusType = void 0;
exports.isAuthorized = isAuthorized;
function isAuthorized(status, handlerType, logger) {
    const loggerHandler = logger.getHandler();
    const sanitizedHandlerType = Array.isArray(loggerHandler) ? loggerHandler : [loggerHandler];
    return exports.STATUS_PRIORITIES[status] >= exports.STATUS_PRIORITIES[logger.getLevel()] && sanitizedHandlerType.includes(handlerType);
}
exports.StatusType = {
    ok: 'ok',
    debug: 'debug',
    info: 'info',
    notice: 'notice',
    warn: 'warn',
    error: 'error',
    critical: 'critical',
    alert: 'alert',
    emerg: 'emerg',
};
exports.STATUS_PRIORITIES = {
    [exports.StatusType.ok]: 0,
    [exports.StatusType.debug]: 1,
    [exports.StatusType.info]: 2,
    [exports.StatusType.notice]: 4,
    [exports.StatusType.warn]: 5,
    [exports.StatusType.error]: 6,
    [exports.StatusType.critical]: 7,
    [exports.StatusType.alert]: 8,
    [exports.StatusType.emerg]: 9,
};
//# sourceMappingURL=isAuthorized.js.map